import { Typography } from 'antd';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import { ModalMap } from '../tabs/ModalMap';
import { TitleSummary } from '../../style';
import { useDictionaryTranslation } from '../../../../hooks/useDictionaryTranslation';

export const BarCodeComponents = ({ field }) => {
  const formatDate = (date) => date && moment(date).format('dddd DD MMMM YYYY (HH:mm:ss)');
  const { Text } = Typography;
  const { translate: t } = useDictionaryTranslation();
  const [isOpenMapModal, setIsOpenMapModal] = useState(false);

  const openMapModal = () => {
    setIsOpenMapModal(true);
  };

  const closeMapModal = () => {
    setIsOpenMapModal(false);
  };

  return (
    <>
      <React.Fragment key={field.idInput}>
        <TitleSummary level={5}>{field.label}</TitleSummary>
        <p>
          <Text strong>{t('informationCaptured')}</Text>
          {field?.value ? (field?.value?.barcodeText) : t('noValue')}
          {field?.value?.barcodeText}
        </p>
        <p>
          {formatDate(field?.value?.time)}  {field?.value ? (<>-<Link onClick={openMapModal}> Mostrar ubicación</Link> </>) : null}
        </p>
      </React.Fragment>

      <ModalMap show={isOpenMapModal} handleClose={closeMapModal} coordsInfo={field} />
    </>
  );
};

BarCodeComponents.propTypes = {
  field: PropTypes.object.isRequired,
};
